export const works = [
  {
    name: "AiDash",
    role: "SDE 3",
    domain: "AiDASH is an enterprise AI company",
    year: "Apr, 2026 - Present",
    location: "Bengaluru, Karnataka",
    image: "aidash.jpeg",
    website: "https://www.aidash.com"
  },
  {
    name: "PharmEasy",
    role: "Senior Software Engineer",
    domain: "Online Medicine Retail Store",
    year: "Nov, 2019 - Apr, 2026",
    location: "Bengaluru, Karnataka",
    image: "pharmeasy.png",
    website: "https://pharmeasy.in"
  },
  {
    name: "Envestnet Yodlee",
    role: "Software Engineer",
    domain: "Fintech - Personal Finance Management",
    year: "July, 2017 - Nov, 2019",
    location: "Bengaluru, Karnataka",
    image: "yodlee.png",
    website: "https://yodlee.com"
  }
]